import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { selectors } from '@lbmx/app-state';
import { select, Store } from '@ngrx/store';
@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss']
})
export class ContactSupportComponent implements OnInit {
 constructor(
    private location: Location,
    private store: Store
  ) { }
  public customerName: string;
  public customerLBMXID: string;
  public ngOnInit(): void {
    this.store.pipe(select(selectors.userProfile)).subscribe((res) => {
        this.customerName = res.userInfo.CompanyName;
        this.customerLBMXID = res.userInfo.AccountLBMXId.toString();
      });
    window.location.href = `mailto:support@lbmx.com?subject=Test Tool Support Request - ${this.customerName} ${this.customerLBMXID}&body=`;
    this.location.back();
  }
}
